import type { PropsWithChildren } from 'react';
import { getLocalTimeZone } from '@internationalized/date';
import { useRealmAuthContext } from '@interxfi/api-client';
import { TimeZoneProvider } from '@interxfi/design-system/time-zone-context';

const systemTimeZone = getLocalTimeZone();

export function WrappedTimeZoneProvider({ children }: PropsWithChildren) {
  const authContext = useRealmAuthContext();

  return <TimeZoneProvider timeZone={authContext?.data?.preferences?.timeZone || systemTimeZone}>{children}</TimeZoneProvider>;
}
